import { useState } from "react";
import { useAuth } from "@/state/auth";
import { Button } from "./ui";

/**
 * A standing, unmissable banner for the whole impersonated session.
 *
 * Amber rather than red on purpose: this is not an error, it is a state that a
 * human must not forget they are in. The account name is spelled out because
 * the danger is not knowing you are impersonating, it is forgetting which
 * customer you are impersonating before you change something.
 */
export function ImpersonationBanner() {
  const { account, user, roleLabel, stopImpersonation } = useAuth();
  const [busy, setBusy] = useState(false);

  async function exit() {
    setBusy(true);
    try {
      await stopImpersonation();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="sticky top-0 z-30 border-b border-accent-strong/30 bg-accent-soft">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-4 py-2.5 lg:px-8">
        <span className="rounded-full bg-accent px-2.5 py-1 text-2xs font-bold uppercase text-white">
          Impersonating
        </span>
        <p className="min-w-0 flex-1 text-sm text-ink-800">
          You are acting as{" "}
          <span className="font-semibold">
            {user ? `${user.first_name} ${user.last_name}` : "this user"}
          </span>{" "}
          ({roleLabel}) on{" "}
          <span className="font-semibold">{account?.trading_name || account?.legal_name}</span>. This
          session is logged and expires in 30 minutes.
        </p>
        <Button size="sm" variant="secondary" loading={busy} onClick={exit}>
          Return to my account
        </Button>
      </div>
    </div>
  );
}
